<div class="modal-header">
  <h4 class="modal-title pull-left">Agregar Dirección</h4>
  <button
    name="modalAddressRef"
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="modalAddressRef.hide()"
  >
    <!-- <span aria-hidden="true">&times;</span> -->
  </button>
</div>
<div class="modal-body">
  @if (loadingForm) {
  <app-loading-element [text]="'Registrando Dirección'"></app-loading-element>
  }
  <div class="row mb-3">
    <div class="col-12">
      <app-map
        (clearAddress)="clearAddress()"
        [storeAddress]="tienda?.direccion || ''"
        [storeZone]="tienda?.zona || ''"
        [autocompletado]="autocompletado"
        (changeAddress)="set_direccion($event)"
        (changeCoordinates)="geolocalizacion($event)"
      />
    </div>
  </div>
  <form (ngSubmit)="agregarDireccion()" [formGroup]="formDireccion">
    <div class="row">
      @if(country=='pe'){

      <div class="mb-3 col-md-6">
        <ng-select
          [clearable]="false"
          [searchable]="true"
          [items]="departamento"
          bindLabel="nombre"
          bindValue="nombre"
          formControlName="depto"
          class="form-control-select"
          placeholder="Departamento*"
          (change)="onSelectDepartamento($event)"
        >
        </ng-select>
      </div>

      <div class="mb-3 col-md-6">
        <ng-select
          [clearable]="false"
          [searchable]="true"
          [items]="provincia"
          bindLabel="nombre"
          bindValue="codigo"
          formControlName="provi"
          class="form-control-select"
          placeholder="Provincia*"
          (change)="onSelectProvincia($event)"
        >
        </ng-select>
      </div>

      <div class="mb-3 col-md-12">
        <ng-select
          [clearable]="false"
          [searchable]="true"
          [items]="distrito"
          bindLabel="nombre"
          bindValue="codigo"
          formControlName="comuna"
          class="form-control-select"
          placeholder="Distrito*"
          (change)="selecionarDistrito($event)"
        >
        </ng-select>
      </div>

      }

      <div class="mb-3 md:col-8">
        <label>Calle (*)</label>
        <input
          type="text"
          class="form-control"
          formControlName="calle"
          (blur)="cargarDireccion()"
        />
      </div>

      <div class="mb-3 md:col-4">
        <label for="inputPassword4">Número</label>
        <input
          type="number"
          class="form-control"
          formControlName="numero"
          (blur)="cargarDireccion()"
          maxLength="9"
          min="1"
          max="999999999"
          appPhoneChar
        />
      </div>

      @if(country=='es'){
      <div class="mb-3 md:col-6">
        <label>Provincia</label>
        <input
          type="text"
          class="form-control"
          formControlName="provincia"
          (blur)="cargarDireccion()"
        />
      </div>

      <div class="mb-3 md:col-6">
        <label>Localidad</label>
        <input
          type="text"
          class="form-control"
          formControlName="localizacion"
          (blur)="cargarDireccion()"
        />
      </div>

      <div class="mb-3 md:col-6">
        <label>Tipo de vía</label>
        <p-dropdown
          [options]="streetTypes"
          formControlName="streetType"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          placeholder="Selecciona tipo de vía"
        ></p-dropdown>
      </div>

      <div class="mb-3 md:col-6">
        <label>Código Postal</label>
        <input
          type="text"
          class="form-control"
          formControlName="codigoPostal"
          (blur)="cargarDireccion()"
          (keypress)="soloNumeros($event)"
          maxlength="5"
        />
      </div>
      } @if(country=='cl'){

      <div class="mb-3 md:col-6">
        <label>Departamento</label>
        <input
          type="text"
          class="form-control"
          formControlName="depto"
          (blur)="cargarDireccion()"
        />
      </div>

      <div class="mb-3 md:col-6">
        <label>Comuna (*)</label>
        <ng-select
          [clearable]="false"
          [searchable]="true"
          [items]="cities"
          bindLabel="city"
          bindValue="id"
          formControlName="comuna"
          class="form-control-select form-control"
          placeholder="Comuna*"
          (blur)="cargarDireccion()"
          (change)="obtenerLocalidades($event)"
        >
        </ng-select>
      </div>

      <div class="mb-3 md:col-6" hidden>
        <label for="inputPassword4">Localización (*)</label>
        @if (!localidades) {
        <div>
          <p>Seleccione una comuna para ver localidades</p>
        </div>
        } @if (localidades) {
        <div>
          <ng-select
            [clearable]="false"
            [searchable]="true"
            [items]="localidades"
            bindLabel="localidad"
            bindValue="localidad"
            formControlName="localizacion"
            class="form-control-select form-control"
            placeholder="Comuna*"
            (change)="cargarDireccion()"
            (blur)="cargarDireccion()"
          >
          </ng-select>
        </div>
        }
      </div>
      <div class="mb-3 md:col-12">
        <label for="validationTextarea">Referencia</label>
        <textarea
          class="form-control"
          placeholder="Ingrese referencia para su direccion"
          formControlName="referencia"
        ></textarea>
      </div>
      } @else{
      <div class="mb-3 md:col-12">
        <label for="validationTextarea">Referencia</label>
        <textarea
          class="form-control"
          placeholder="Ejm: Tipo de Vía / Urb. / Km / Mz / Lote / Dpto."
          formControlName="referencia"
        ></textarea>
      </div>

      }
      <div *ngIf="country === 'es'">
        <hr />
        <h5 class="mb-3">Datos de contacto</h5>

        <div class="row">
          <div class="col-6 mb-3">
            <label>NIF</label>
            <input
              formControlName="contactRut"
              type="text"
              class="form-control"
              [placeholder]="config.document.name + '*'"
              (input)="noCharNIF($event)"
              (blur)="onNifBlur()"
            />
            <small
              *ngIf="
                formDireccion.get('contactRut')?.invalid &&
                formDireccion.get('contactRut')?.touched
              "
              class="text-danger"
            >
              El {{ config.document.name }} ingresado no es válido
            </small>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mb-3">
            <label>Nombre</label>
            <input
              formControlName="nombre"
              type="text"
              class="form-control"
              placeholder="Nombres *"
            />
          </div>
          <div class="col-6 mb-3">
            <label>Apellido</label>
            <input
              formControlName="apellido"
              type="text"
              class="form-control"
              placeholder="Apellidos *"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-6 mb-3">
            <label>Telefono</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  <i
                    [ngClass]="
                      selectedPhoneCode == config.phoneCodes.mobile.code
                        ? 'fa-solid fa-mobile-screen'
                        : 'fa-solid fa-phone'
                    "
                  ></i>
                  {{ selectedPhoneCode }}
                </button>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    (click)="selectFono(config.phoneCodes.mobile.code)"
                  >
                    <i class="fa-solid fa-mobile-screen"></i>
                    {{ config.phoneCodes.mobile.code }}
                  </a>
                  <a
                    class="dropdown-item"
                    (click)="selectFono(config.phoneCodes.landline.code)"
                  >
                    <i class="fa-solid fa-phone"></i>
                    {{ config.phoneCodes.landline.code }}
                  </a>
                </div>
              </div>

              <input
                formControlName="telefono"
                type="text"
                class="form-control"
                placeholder="Número*"
                maxlength="9"
                (keypress)="soloNumeros($event)"
              />
            </div>
            <small
              *ngIf="
                formDireccion.get('telefono')?.invalid &&
                formDireccion.get('telefono')?.touched
              "
              class="text-danger"
              >El número de contacto no es válido</small
            >
          </div>

          <div class="col-6 mb-3">
            <label>Email</label>
            <input
              formControlName="email"
              type="email"
              class="form-control"
              placeholder="Email *"
            />
            <small
              *ngIf="
                formDireccion.get('email')?.invalid &&
                formDireccion.get('email')?.touched
              "
              class="text-danger"
            >
              Ingresa un e‑mail válido
            </small>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    name="cerrar"
    class="btn btn-danger"
    (click)="modalAddressRef.hide()"
  >
    Cancelar
  </button>
  <button
    name="agregarDireccion"
    class="btn btn-secondary"
    (click)="agregarDireccion()"
    [disabled]="!formDireccion.valid"
  >
    Agregar
  </button>

  <!-- <button
    *ngIf="country === 'es'"
    class="btn btn-secondary"
    (click)="registrarContactoYDireccion(emailValidate)"
    [disabled]="
      !formDireccion.valid ||
      !formDireccion.get('contacto').valid ||
      loadingForm ||
      !emailValidate.isValidEmail
    "
  >
    Agregar
  </button>> -->
</div>
